import { render, staticRenderFns } from "./DataAccessGrid.vue?vue&type=template&id=49241be0"
import script from "./DataAccessGrid.vue?vue&type=script&lang=js"
export * from "./DataAccessGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports